export enum SpinnerNames {
  principal = 'principalSpinner',
  catalogs = 'catalogs',
  doctorList = 'doctorList',
  generalList = 'list',
  generalSearch = 'generalSearch',
  msi = 'msi'
}
